module.exports = __webpack_public_path__ + "redmine-logo.png";


//////////////////
// WEBPACK FOOTER
// ./images/integrations/redmine-logo.png
// module id = 1266
// module chunks = 74